const index = () => import('./the-vitae-profile')
// const dashboard = () => import('@app/vp')
// const profile = () => import('@app/admin/usuarios/form')

export default [
  {
    path: '/vp',
    name: 'vp.index',
    component: index
  }
]



// WEBPACK FOOTER //
// ./src/components/vp/routes.js